// @flow
import React, { useState, useMemo } from 'react'
import { View, TouchableOpacity } from 'react-native'

import { ASTROLABE_VERSION } from '../../../../api'
import Row from '../../../../components/Row'
import Desc from '../Desc'
import Palace from '../Palace'
import themes from '../../../global/themes'

type AstrolabeProps = {
  theme?: Object,
  astrolabe: Object,
  ta: Object,
  t: Function,
  containerStyle?: Object,
  isWideScreen: Boolean,
}
const Astrolabe = ({
  theme,
  astrolabe,
  ta,
  t,
  containerStyle,
  isWideScreen,
  version = ASTROLABE_VERSION.FULL,
}: AstrolabeProps) => {
  const { palette } = theme

  const [relationship, setRelationship] = useState(-1)

  return (
    <View
      style={{
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: palette.background.default,
        ...containerStyle,
      }}>
      <Row
        style={{
          flex: 1,
          marginVertical: 0,
        }}>
        <TouchableOpacity
          activeOpacity={0.7}
          onPress={() => setRelationship(5)}
          style={{ flex: 1, height: '100%' }}>
          <Palace
            theme={theme}
            branch={astrolabe ? astrolabe.branches[5] : null}
            version={version}
            isWideScreen={isWideScreen}
          />
        </TouchableOpacity>
        <TouchableOpacity
          activeOpacity={0.7}
          onPress={() => setRelationship(6)}
          style={{ flex: 1, height: '100%' }}>
          <Palace
            theme={theme}
            branch={astrolabe ? astrolabe.branches[6] : null}
            version={version}
            isWideScreen={isWideScreen}
          />
        </TouchableOpacity>
        <TouchableOpacity
          activeOpacity={0.7}
          onPress={() => setRelationship(7)}
          style={{ flex: 1, height: '100%' }}>
          <Palace
            theme={theme}
            branch={astrolabe ? astrolabe.branches[7] : null}
            version={version}
            isWideScreen={isWideScreen}
          />
        </TouchableOpacity>
        <TouchableOpacity
          activeOpacity={0.7}
          onPress={() => setRelationship(8)}
          style={{ flex: 1, height: '100%' }}>
          <Palace
            theme={theme}
            branch={astrolabe ? astrolabe.branches[8] : null}
            style={{ borderRightWidth: 1 }}
            version={version}
            isWideScreen={isWideScreen}
          />
        </TouchableOpacity>
      </Row>
      <Row style={{ flex: 2, marginVertical: 0 }}>
        <View style={{ flex: 1, height: '100%' }}>
          <TouchableOpacity
            activeOpacity={0.7}
            onPress={() => setRelationship(4)}
            style={{ flex: 1, height: '100%' }}>
            <Palace
              theme={theme}
              branch={astrolabe ? astrolabe.branches[4] : null}
              version={version}
              isWideScreen={isWideScreen}
            />
          </TouchableOpacity>
          <TouchableOpacity
            activeOpacity={0.7}
            onPress={() => setRelationship(3)}
            style={{ flex: 1, height: '100%' }}>
            <Palace
              theme={theme}
              branch={astrolabe ? astrolabe.branches[3] : null}
              version={version}
              isWideScreen={isWideScreen}
            />
          </TouchableOpacity>
        </View>
        <View
          style={{
            flex: 2,
            height: '100%',
            borderLeftWidth: 1,
            borderTopWidth: 1,
            borderColor: palette.border,
          }}>
          <TouchableOpacity
            activeOpacity={1.0}
            onPress={() => setRelationship(-1)}
            style={{ flex: 1, height: '100%' }}>
            {version > ASTROLABE_VERSION.PREVIEW && (
              <Desc
                theme={theme}
                ta={ta}
                astrolabe={astrolabe}
                relationship={relationship}
                t={t}
              />
            )}
          </TouchableOpacity>
        </View>
        <View style={{ flex: 1, height: '100%' }}>
          <TouchableOpacity
            activeOpacity={0.7}
            onPress={() => setRelationship(9)}
            style={{ flex: 1, height: '100%' }}>
            <Palace
              theme={theme}
              branch={astrolabe ? astrolabe.branches[9] : null}
              style={{ borderRightWidth: 1 }}
              version={version}
              isWideScreen={isWideScreen}
            />
          </TouchableOpacity>
          <TouchableOpacity
            activeOpacity={0.7}
            onPress={() => setRelationship(10)}
            style={{ flex: 1, height: '100%' }}>
            <Palace
              theme={theme}
              branch={astrolabe ? astrolabe.branches[10] : null}
              style={{ borderRightWidth: 1 }}
              version={version}
              isWideScreen={isWideScreen}
            />
          </TouchableOpacity>
        </View>
      </Row>
      <Row style={{ flex: 1, borderBottomWidth: 0, marginVertical: 0 }}>
        <TouchableOpacity
          activeOpacity={0.7}
          onPress={() => setRelationship(2)}
          style={{ flex: 1, height: '100%' }}>
          <Palace
            theme={theme}
            branch={astrolabe ? astrolabe.branches[2] : null}
            style={{ borderBottomWidth: 1 }}
            version={version}
            isWideScreen={isWideScreen}
          />
        </TouchableOpacity>
        <TouchableOpacity
          activeOpacity={0.7}
          onPress={() => setRelationship(1)}
          style={{ flex: 1, height: '100%' }}>
          <Palace
            theme={theme}
            branch={astrolabe ? astrolabe.branches[1] : null}
            style={{ borderBottomWidth: 1 }}
            version={version}
            isWideScreen={isWideScreen}
          />
        </TouchableOpacity>
        <TouchableOpacity
          activeOpacity={0.7}
          onPress={() => setRelationship(0)}
          style={{ flex: 1, height: '100%' }}>
          <Palace
            theme={theme}
            branch={astrolabe ? astrolabe.branches[0] : null}
            style={{ borderBottomWidth: 1 }}
            version={version}
            isWideScreen={isWideScreen}
          />
        </TouchableOpacity>
        <TouchableOpacity
          activeOpacity={0.7}
          onPress={() => setRelationship(11)}
          style={{ flex: 1, height: '100%' }}>
          <Palace
            theme={theme}
            branch={astrolabe ? astrolabe.branches[11] : null}
            style={{ borderBottomWidth: 1, borderRightWidth: 1 }}
            version={version}
            isWideScreen={isWideScreen}
          />
        </TouchableOpacity>
      </Row>
    </View>
  )
}
export default Astrolabe
